export const brandVariables = (brand) => {
    if (brand === 'finn')
        return `
          ${ /* Colors */''}
          --trust-primary: #0063FB;
          --trust-primary__hover: #004FC9;
          --trust-primary__active: #003B97;
          --trust-secondary: white;
          --trust-secondary__hover:#F1F9FF;
          --trust-surface-primary: #f1f9ff;
          --trust-surface-secondary: white;
          --trust-text-primary: #464646;
          --trust-text-secondary: #767676;
          --trust-icon-primary:#767676;

          --trust-background-primary: #C3CCD9;
          --trust-background-secondary: white;

          ${ /* Typografy - uses default for finn */''}
          ${ /* See defaults in input.css */''}
        `;
    else
        return `
          ${ /* Colors */''}
          --trust-primary: #0071EB;
          --trust-primary__hover: #0093FF;
          --trust-primary__active: #163FB9;
          --trust-secondary: white;
          --trust-secondary__hover:#eff6ff;
          --trust-surface-primary: #FFFFFF;
          --trust-text-primary: #000;
          --trust-text-secondary:#767473;
          --trust-icon-primary: #363433;
          --trust-bluegray: #BEBCBB;
          --trust-stepper: #F71414;
          --trust-stepper__hover: #f87171;
          --trust-tip-box: #E2F2FF;

          --trust-background-primary: #FFF;
          --trust-background-secondary: #F6F4F3;

          ${ /* Typografy */''}
          --trust-h1-size: 28px;
          --trust-h1-line-height:40px;
          --trust-h1-weight: 700;

          --trust-h2-size: 24px;
          --trust-h2-line-height: 28px;
          --trust-h2-weight: 700;

          --trust-h3-size: 22px;
          --trust-h3-line-height: 28px;;
          --trust-h3-weight: 500;

          --trust-h4-size: 17px;
          --trust-h4-line-height: 26px;
          --trust-h4-weight: 500;

          --trust-a-size: 17px;
          --trust-a-line-height: 26px;
          --trust-a-weight: 400;

          --trust-p-size: 17px;
          --trust-p-line-height: 26px;
          --trust-p-weight: 400;
          --trust-p-strong-weight: 500;

          --trust-caption-size: 15px;
          --trust-caption-line-height: 20px;
          --trust-caption-weight: 400;
          --trust-caption-strong-weight: 500;

          --trust-detail-size: 12px;
          --trust-detail-line-height: 20px;
          --trust-detail-weight: 400;
          --trust-detail-strong-weight: 500;
      `;
};
//# sourceMappingURL=BrandVariables.js.map